import { render, staticRenderFns } from "./CaseQuantity.vue?vue&type=template&id=499af139&scoped=true"
import script from "./CaseQuantity.vue?vue&type=script&lang=js"
export * from "./CaseQuantity.vue?vue&type=script&lang=js"
import style0 from "./CaseQuantity.vue?vue&type=style&index=0&id=499af139&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499af139",
  null
  
)

export default component.exports